import { render } from "./Checkbox.vue?vue&type=template&id=39cd066f&scoped=true&bindings={}"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"

import "./Checkbox.vue?vue&type=style&index=0&id=39cd066f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-39cd066f"

export default script